import secureStorage from "../utils/SecureStorage";
import config from "../configs/config.app";

const ServiceStorage = {
  setToken: (accessToken, refreshToken = null) => {
    secureStorage.setItem(config.accessToken, accessToken);
    secureStorage.setItem(config.refreshToken, refreshToken);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.accessToken + "_DEV", accessToken);
      localStorage.setItem(config.refreshToken + "_DEV", refreshToken);
    }
  },

  setUserInfo: (userInfo) => {
    secureStorage.setItem(config.userInfo, userInfo);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      localStorage.setItem(config.userInfo + "_DEV", JSON.stringify(userInfo));
    }
  },

  getAccessToken: () => {
    return secureStorage.getItem(config.accessToken);
  },

  getRefreshToken: () => {
    return secureStorage.getItem(config.refreshToken);
  },

  clearToken: () => {
    secureStorage.clear();
    localStorage.clear();
  },
};

export default ServiceStorage;
